import React, { useState, useContext, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import MyChatComponent from './MyChatComponent';
import ShareButton from './ShareButton';
import CopyTextButton from './CopyTextButton';
import TagsInput from './TagsInput';
import PeopleTags from './PeopleTags';
import { Link, useNavigate } from 'react-router-dom';
import PlatformRatings from './PlatformRatings.js';

// TODO: get rid of isDropdown, it's always false
// eventType: like, /*recommendationIncoming, recommendationOutgoing,*/ recommendation
const CardEventArtChat = ({ event, eventType, art, chatInfo, language, userName, userInfo, misc, chatState, isDropdown=false, chatFillHeight=false }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate();

  const artLink = art.wikiArticleLink;
  const hostnameParts = new URL(artLink).hostname.split('.');
  const secondLevelDomain = hostnameParts[1];
  let iconFile = "/wiki_icon.png";
  if (secondLevelDomain === 'steampowered') {
    iconFile = "/steam_icon.png";
  } else if (secondLevelDomain == 'imdb') {
    iconFile = "/imdb_icon.png"
  } else if (secondLevelDomain == 'apple') {
    iconFile = "/applebooks_icon.png"
  }

  const elementRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
        }
      },
      {
        threshold: 0.1, // Adjust the threshold as needed
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      element.style.overflow = 'hidden'; // Disable scroll for the main component
    }
    return () => {
      if (element) {
        element.style.overflow = ''; // Reset overflow on cleanup
      }
    };
  }, []);

  const [eventId, setEventId] = useState(event.id);
  const [eventTags, setEventTags] = useState(event.eventTags);
  const [eventChatId, setEventChatId] = useState(event.chatId);
  const [eventChatInfo, setEventChatInfo] = useState(chatInfo);

  const [removed, setRemoved] = useState(false);
  const handleEventRemove = (eventId) => {
    axiosInstance
    .delete(`/artEvents/${eventId}`)
    .then((response) => {
      alert("Removed / Удалено");
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const handleEventTag = (eventId, inputTagNames) => {
    axiosInstance
    .post(`/artEvents/tag/${eventId}/tag`, { tags: inputTagNames })
    .then((response) => {
      setEventTags(response.data.event.eventTags);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const [participates, setParticipates] = useState(chatInfo ? chatInfo.participates : false);
  const handleSubscribe = () => {
    axiosInstance.post(`/chats/${eventChatId}/participation`).then(() => {
      setParticipates(true);
    });
  };
  const handleUnsubscribe = () => {
    axiosInstance.delete(`/chats/${eventChatId}/participation`).then(() => {
      setParticipates(false);
    });
  };

  const [pinned, setPinned] = useState(event.pinned);
  const handleEventPin = (eventId) => {
    axiosInstance
    .post(`/artEvents/pin/${eventId}/pin`)
    .then((response) => {
      setPinned(true);
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 406) {
          alert(localizeKey('pinsLimitReached', language));
        } else {
          console.error(error);
        }
      } else {
        console.error(error);
      }
    })
  }
  const handleEventUnpin = (eventId) => {
    axiosInstance
    .delete(`/artEvents/pin/${eventId}/pin`)
    .then((response) => {
      setPinned(false);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  const isRecommendation = event.eventTags && event.eventTags.some(tag => tag.type === 2);

  const [selectedRecommendationUserTag, setSelectedRecommendationUserTag] = useState(
    isRecommendation ? event.eventTags?.[0] || null : null
  );
  useEffect(() => {
    if (!isRecommendation) {
      return;
    }
    if (!selectedRecommendationUserTag && eventTags && eventTags.length > 0) {
      setSelectedRecommendationUserTag(eventTags[0]);
    }
  }, [isRecommendation, eventTags, selectedRecommendationUserTag]);
  const updatePersonalRecomChatId = (selectedTag) => {
    console.log("selected tag", selectedTag);
    if (!selectedTag) {
      return;
    }
    if (selectedRecommendationUserTag && selectedTag.id === selectedRecommendationUserTag.id) {
      return; // no need to request from backend
    }
    axiosInstance
    .get(`/artEvents/${eventId}?recommendationUserId=${selectedTag.creatorUser}`)
    .then((response) => {
      if (response.data.event.chatId === eventChatId) { // something went wrong, same chat returned for different user
        console.error("same private chat returned for different user");
        return;
      }
      setEventChatId(response.data.event.chatId);
      setSelectedRecommendationUserTag(selectedTag);
      setEventChatInfo(response.data.chat);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  // const recomNotFinished = eventType === "recommendation" && art.myEventType !== "like" && art.myEventType !== "finished";
  let outerClassModification = "";
  // if (false && removed) { // todo: refactor
  //   outerClassModification = "pointer-events-none grayscale";
  // } else if (recomNotFinished) {
  //   outerClassModification = "border border-blue-400 rounded-lg shadow outline-1";
  // }

  const queryParams = new URLSearchParams(window.location.search);
  const tagsInitFocus = queryParams.get('tagsInitFocus') === 'true';

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isLogbookModalVisible, setIsLogbookModalVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleDropdownAction = (action) => {
    if (action === 'pin') {
      if (pinned) {
        handleEventUnpin(eventId);
      } else {
        handleEventPin(eventId);
      }
    } else if (action === 'remove') {
      if (window.confirm(language === "ru" ? "Вы уверены, что хотите удалить произведение из своей библиотеки?" : "Are you sure you want to remove the art from your library?")) {
        handleEventRemove(eventId);
      }
    } else if (action === 'logbook') {
      navigate(`/logbook?artEventId=${event.id}`);
    } else if (action === 'toggleNotifications') {
      if (participates) {
        handleUnsubscribe();
      } else {
        handleSubscribe();
      }
    }
    setDropdownVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownVisible && !event.target.closest('.dropdown-container')) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisible]);

  const logbookDateTime = event.logbookDateTimes && event.logbookDateTimes.length > 0 ? new Date(event.logbookDateTimes[0]) : null;

  const chatComponentRef = useRef(null); // Ref for MyChatComponent

  useEffect(() => {
    if (chatState !== "hidden" && chatComponentRef.current) {
      chatComponentRef.current.focus(); // Focus on MyChatComponent when opened
    }
  }, [chatState]);

  return (
    <>
      <div
        ref={elementRef}
        class={
          (outerClassModification !== "" ? outerClassModification + " " : "") +
          "mx-auto max-w-xl" +
          (chatFillHeight ? " flex h-full flex-col min-h-0" : "")
        }
      >
        <div class={chatFillHeight ? "shrink-0" : ""}>
        <div className="mx-auto w-auto flex flex-row pb-2 shadow max-w-xl" style={{ borderBottom: '1px solid var(--mantine-color-default-border)' }}>
        {!isDropdown &&
          <div>
            <Link to={"https://wowcontent.lol/arts/"+art.id} >
              <img className="object-cover rounded-t-lg h-auto min-w-20 w-20 md:min-w-20 md:w-20 rounded-none rounded-s-lg" src={art.thumbnailUrl} alt=""/>
            </Link>
            <div className="mt-1">
              <PlatformRatings art={art} />
            </div>
          </div>
        }
          <div className="w-full">
          <div className="flex items-center">
            <div className="text-lg ml-2 md:ml-4 flex-1 min-w-0">
              {
              (eventType !== "recommendation")
              ?
                <div className="flex text-sm items-center mt-1">
                  {
                  eventType === "like"
                  ?
                    <>
                      <Link to={`https://wowcontent.lol/users/${event.userID}/likes`}>
                        <img className="rounded-full aspect-square max-w-8 max-h-8" src={userInfo.avatarUrl}/>
                      </Link>
                      <div>                  
                          &nbsp;
                          <span className="font-bold">
                            {(myUser && myUser.myUserInfo.myUserId === event.userID) ? ("") : userInfo.name}
                          </span>
                        {/* <span className="font-bold">
                          &nbsp;{localizeKey('addedToTheirLib', language)}
                        </span> */}
                        <span className="font-bold">
                          {
                            (myUser && myUser.myUserInfo.myUserId === event.userID) ? 
                              (language === "ru" ? "обсуждение в моей библиотеке" : "discussion in my library") :
                              (language === "ru" ? ": обсуждение в библиотеке у пользователя" : ": discussion in user's library")
                          }
                          
                        </span>

                        <div className="px-1 hover:underline leading-none">
                          <Link className="text-sm" style={{ color: 'var(--mantine-color-dimmed)' }} to={"https://wowcontent.lol/" + (eventType === "recommendation" ? "recommendations/" : "artEvents/") + event.id}>
                            {new Date(event.createdTime).toLocaleDateString(language, { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })}
                          </Link>
                        </div>
                      </div>
                    </>
                  :
                    <div className="font-bold">
                      {
                      eventType === "recommendationIncoming" 
                      ? 
                        (language === "ru" ? "Рекомендовали вам персонально" : "Recommended to you personally")
                      :
                        (language === "ru" ? "Вы рекомендовали персонально" : "You recommended personally")
                      }
                    </div>
                  }
                </div>
              :
                <div className="text-sm font-bold">
                  {language === "ru" ? "Персональная рекомендация" : "Personal recommendation"}
                </div>
              }

              <div className="flex items-center text-base leading-none mt-1">
                <span>{'«' + localizeArt(art, language).name.trim() /*remove this trim eventually*/ + '»' + (art.year ? ` (${art.year})`: "")}</span>&#32;
              </div>
            </div>
            {!isDropdown && myUser && (
              <div className="flex items-center shrink-0 ml-2 mr-1">
                {pinned && (
                  <div className="text-xl mr-1">
                    📌
                  </div>
                )}
                <div className="relative dropdown-container">
                  <div
                    className="cursor-pointer text-xl px-1"
                    onClick={toggleDropdown}
                  >
                    &#x22EF;
                  </div>
                  {dropdownVisible && (
                    <div className="absolute right-0 mt-2 w-48 rounded shadow-lg z-10" style={{ backgroundColor: 'var(--mantine-color-body)', border: '1px solid var(--mantine-color-default-border)' }}>
                      <div
                        className="px-4 py-2 cursor-pointer text-sm"
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--mantine-color-default-hover)'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                        onClick={() => handleDropdownAction('toggleNotifications')}
                      >
                        {participates
                          ? localizeKey('unsubscribeFromChat', language)
                          : localizeKey('subscribeToChat', language)}
                      </div>
                      {myUser.myUserInfo.myUserId === event.userID && (
                        <>
                          <div
                            className="px-4 py-2 cursor-pointer text-sm"
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--mantine-color-default-hover)'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                            onClick={() => handleDropdownAction('pin')}
                          >
                            {pinned ? (language === "ru" ? "Открепить в моей библиотеке" : "Unpin in my library") : (language === "ru" ? "Закрепить в моей библиотеке" : "Pin in my library")}
                          </div>
                          <div
                            className="px-4 py-2 cursor-pointer text-sm"
                            style={{ color: 'var(--mantine-color-red-text)' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--mantine-color-default-hover)'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                            onClick={() => handleDropdownAction('remove')}
                          >
                            {language === "ru" ? "Удалить из моей библиотеки" : "Remove from my library"}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

            <div className="ml-2 md:ml-4 text-sm">
              {
                eventType === 'recommendation' &&
                (
                  myUser && misc.fromUser.id === myUser.myUserInfo.myUserId ? // myUser && is to allow non-logged-in which is unnecessary
                    <div className="flex items-center">
                      {localizeKey('toWhomRecommended', language)}:&nbsp;
                      <Link className="flex items-center" to={`/users/${misc.toUser.id}/likes`}>
                        <img className="rounded-full max-w-8 max-h-8" src={misc.toUser.avatarUrl}/>
                        &nbsp;
                        <span style={{ color: 'var(--mantine-color-blue-text)' }}>
                          {misc.toUser.userName}
                        </span>
                      </Link>
                    </div>
                  :
                    <div className="flex items-center">
                      {localizeKey('byWhomRecommended', language)}:&nbsp;
                      <Link className="flex items-center" to={`/users/${misc.fromUser.id}/likes`}>
                        <img className="rounded-full max-w-8 max-h-8" src={misc.fromUser.avatarUrl}/>
                        &nbsp;
                        <span style={{ color: 'var(--mantine-color-blue-text)' }}>
                          {misc.fromUser.userName}
                        </span>
                      </Link>
                    </div>
                )
              }
              {
                logbookDateTime && (
                  <div className="text-sm" style={{ color: 'var(--mantine-color-dimmed)' }}>
                    {art.category === 1
                      ? (language === "ru" ? "Последний просмотр: " : "Last watch time: ")
                      : art.category === 2
                      ? (language === "ru" ? "Последняя игра: " : "Last play time: ")
                      : art.category === 3
                      ? (language === "ru" ? "Последнее чтение: " : "Last read time: ")
                      : ""}
                    {logbookDateTime.getTime() === 0
                      ? (language === "ru" ? "Давно" : "Long time ago")
                      : logbookDateTime.toLocaleDateString(language, {
                          month: 'long',
                          day: 'numeric',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                        })}
                  </div>
                )
              }
            </div>        

          {!isDropdown &&
            <div className="mt-2">
              {isRecommendation ? (
                <PeopleTags
                  tags={eventTags || []}
                  selectedTagId={selectedRecommendationUserTag ? selectedRecommendationUserTag.id : null}
                  onSelect={updatePersonalRecomChatId}
                  language={language}
                />
              ) : (
                <TagsInput 
                  key={eventId}
                  language={language} 
                  initFocus={tagsInitFocus} 
                  editable={eventType === "like" && myUser && myUser.myUserInfo.myUserId === event.userID}
                  initialTags={eventTags ? eventTags.map((eventTag) => { return eventTag.imgUrl ? eventTag.name + "\\" + eventTag.imgUrl : eventTag.name; }) : []} 
                  initialTagObjects={eventTags ? eventTags : []}
                  onTagsChange={(updatedTags) => {handleEventTag(eventId, updatedTags)}}
                />
              )}
            </div>
          }

          {/*
          <div className="mt-4 flex items-center">
            {
            (chatState === "shown" && myUser && event.userID === myUser.myUserInfo.myUserId) && // chatState check is a hack to check if it's single event page
              <div className="ml-4 text-red-600 hover:text-red-900 hover:cursor-pointer" onClick={() => {
                handleEventRemove(eventId);
              }}>
                {localizeKey('removeFromLib', language)}
              </div>  
            }
          </div>
          */}

          </div>
        </div>
        </div>
        {
        (chatState !== "hidden") &&
        <div class={chatFillHeight ? "flex-1 min-h-0" : ""}>
          {!isDropdown && false ?
            <Collapsible
              collapsed={chatState === "shown" ? false : /*collapsed*/ true }
              beforeTextImgUrl={selectedRecommendationUserTag ? selectedRecommendationUserTag.imgUrl : ""}
              buttonText={
                localizeKey(
                  eventType === 'recommendationIncoming' || eventType === 'recommendationOutgoing' ? 'privateChat' : 'chat',
                  language
                ) + " (" + eventChatInfo.messageCount + " " + localizeKey('messages', language) + ")"
              }
            >
              <MyChatComponent
                ref={chatComponentRef} // Attach ref to MyChatComponent
                key={eventChatId}
                chatId={eventChatId}
                _userChatInfo={eventChatInfo}
                language={language}
                myUserInfo={myUser ? myUser.myUserInfo : null}
                chatOwnerInfo={{type:eventType, id: event.id}}
              />
            </Collapsible>
          :
            <MyChatComponent
              ref={chatComponentRef} // Attach ref to MyChatComponent
              key={eventChatId}
              chatId={eventChatId}
              _userChatInfo={eventChatInfo}
              language={language}
              myUserInfo={myUser ? myUser.myUserInfo : null}
              chatOwnerInfo={{type:eventType, id: event.id}}
              isDropdown={false}
              fillHeight={chatFillHeight}
            />
        }
        </div>
        }
      </div>
    </>
  );
}

export default CardEventArtChat;
